import Vue from 'vue'
import App from './App.vue'
import vueModal from 'vue-js-modal';

import store from './store' // vuex store instance

Vue.use(vueModal);

new Vue({
    el: '#app',
    render: h => h(App),
    store
});


// WEBPACK FOOTER //
// ./src/main.js